export enum ActionTypes {
  GET_ACTION_ITEMS = '[GET_ACTION_ITEMS] Get action items',
  GET_ACTION_ITEMS_SUCCESS = '[GET_ACTION_ITEMS] Get action items success',
  GET_ACTION_ITEMS_FAILURE = '[GET_ACTION_ITEMS] Get action items failure',
}
